import React from 'react';
import { SxProps, TextField, Theme } from '@mui/material';

interface MonthPickerProps {
  value: string;
  onChange: (v: string) => void;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

const MonthPicker: React.FC<MonthPickerProps> = ({ value, onChange, fullWidth = false, sx }) => (
  <TextField
    type="month"
    label="Month"
    value={value}
    onChange={(e)=>onChange(e.target.value)}
    InputLabelProps={{ shrink: true }}
    size="small"
    fullWidth={fullWidth}
    sx={sx}
  />
);

export default MonthPicker;
